theme.tickers = (function(){
  const selectors = {
    ticker: '.ticker',
    inner: '.ticker__inner'
  };

  const initTicker = (ticker, config) => {
    if (ticker.childElementCount === 1) {
      let tickerInner = ticker.querySelector(selectors.inner);
      tickerInner.classList.add('ticker--animated');

      for (let index = 0; index < 15; index++) {
        let clone = tickerInner.cloneNode(true);
        clone.setAttribute('aria-hidden', true);
        ticker.appendChild(clone);
      }

      const animationTimeFrame = (tickerInner.clientWidth / config.space) * config.duration;
      ticker.style.setProperty('--duration', `${animationTimeFrame}s`);
    }
  }

  const init = () => {
    let tickers = document.querySelectorAll('.ticker');
  
    tickers.forEach(ticker => {
      let config = {
        duration: parseFloat(ticker.dataset.speed),
        space: 100
      }
  
      theme.utils.whenVisible({
        element: ticker,
        callback: initTicker(ticker, config),
        threshold: 600
      });
    });  
  }
  
  return {
    selectors,
    initTicker,
    init
  }
})();